import axios from 'axios';

// Support for both Vite and Create React App environments
const BASE_URL = import.meta.env?.VITE_API_BASE_URL || process.env.REACT_APP_API_BASE_URL;

const reviewService = {
  
  // 1. LIST (GET)
  getAllReview: async () => {
    try {
      const response = await axios.post(`${BASE_URL}/review/list`);
      
      /** * CHANGE HERE: 
       * Your backend returns: { success: true, data: [...] }
       * We need to return response.data.data
       */
      if (response.data && response.data.success) {
        return response.data.data; 
      }
      
      return [];
    } catch (error) {
      console.error("Fetch Error:", error);
      throw error.response?.data || "Could not fetch projects";
    }
  },

  // 2. CREATE (POST)
  createReview: async (formData) => {
    try {
      const response = await axios.post(`${BASE_URL}/review/create`, formData, {
        headers: {
        'Content-Type': 'application/json'
      }
      });
      
      return response.data;
    } catch (error) {
      throw error.response?.data || "Error adding project";
    }
  },

  // 3. UPDATE (POST)
  updateReview: async (id, reviewData) => {
    try {
      const response = await axios.post(`${BASE_URL}/review/update`, { id , ...reviewData});
      return response.data;
    } catch (error) {
      console.error("Update Review Error:", error);
      throw error.response?.data || "Error updating review";
    }
  },

  // 4. DELETE (POST)
  deleteReview: async (id) => {
    try {
      const response = await axios.post(`${BASE_URL}/review/delete/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || "Error deleting project";
    }
  }
};

export default reviewService;